import ChartAppearance from './ChartAppearance';

export default ChartAppearance;
